<template>
  <el-row>
    <el-form-item label="运输方式" prop="ship_car_type" :rules="filter_rules()">
      <el-select
        placeholder="请选择"
        v-model="ship_car_type"
        @change="changeType"
        :disabled="modify"
      >
        <el-option label="汽运" value="CAR_TYPE"></el-option>
        <el-option label="船运" value="BOAT_TYPE"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="车船号" prop="ship_car_num" :rules="filter_rules()">
      <el-select
        placeholder="请选择车船号"
        filterable
        :remote="getCar"
        v-model="ship_car_num"
        :remote-method="remoteMethod_num"
        @change="change"
        :disabled="modify"
      >
        <el-option
          v-for="(item, index) in numList"
          :disabled="item.is_black == 'Yes'"
          :key="index"
          :label="item.ship_car_num"
          :value="item.pid"
        >
          <slot>
            <span>{{ item.ship_car_num }}</span>
            <span v-if="item.is_black == 'Yes'">黑名单</span>
          </slot>
        </el-option>
      </el-select>
      <i class="iconfont icon-icon12 unit" v-if="getCar"></i>
    </el-form-item>
    <el-form-item label="姓名" prop="carrier_name" :rules="filter_rules()">
      <el-select
        placeholder="请选择姓名"
        filterable
        :remote="getName"
        v-model="carrier_name"
        :remote-method="remoteMethod_name"
        @change="changeName"
        :disabled="modify"
      >
        <el-option
          v-for="(item, index) in nameList"
          :disabled="item.is_black == 'Yes'"
          :key="index"
          :label="item.ship_car_name"
          :value="item.pid"
        >
          <span style="float: left">{{ item.ship_car_name }}</span>
          <span v-if="item.is_black == 'Yes'" style="float: right">黑名单</span>
        </el-option>
      </el-select>
      <i class="iconfont icon-icon12 unit" v-if="getName"></i>
    </el-form-item>
  </el-row>
</template>

<script>
import { isSuccess } from '@/assets/js/utils'
export default {
  data() {
    return {
      numList: [],
      nameList: [],
      getCar: true,
      getName: true,
      modify: this.ifModify,
      ship_car_type: this.type, //车船类型
      ship_car_num: this.num, //车船号
      carrier_name: this.cName, //司机姓名
      carrier_name_pid: this.cPid
    }
  },
  props: ['type', 'num', 'cName', 'cPid', 'ifModify'],
  created() {
    this.ship_car_type = 'CAR_TYPE'
  },
  watch: {
    type: function(newVal, oldVal) {
      this.ship_car_type = newVal
    },
    num: function(newVal, oldVal) {
      this.ship_car_num = newVal
    },
    cName: function(newVal, oldVal) {
      this.carrier_name = newVal
    },
    cPid: function(newVal, oldVal) {
      this.carrier_name_pid = newVal
    },
    ifModify: function(newVal, oldVal) {
      this.modify = newVal
    }
  },
  methods: {
    changeType(val) {
      this.$emit('getType', val)
      this.numList = []
      this.nameList = []
      this.boat_car_pid = ''
      this.carrier_name_pid = ''
      this.carrier_name = ''
      this.ship_car_num = ''
    },
    remoteMethod_num(query) {
      if (!this.ship_car_type) {
        alert('请先选择运输方式')
        return false
      }
      let json = {
        ship_car_num: query,
        name: '',
        ship_car_type: this.ship_car_type
      }
      if (query !== '') {
        api('waybill.car.and.ship.batch.query', json).then((res) => {
          let data
          if ((data = isSuccess(res))) {
            this.numList = data
          }
        })
      }
    },
    remoteMethod_name(query) {
      if (!this.ship_car_type) {
        alert('请先选择运输方式')
        return false
      }
      let json = {
        ship_car_num: '',
        name: query,
        ship_car_type: this.ship_car_type
      }
      if (query !== '') {
        api('waybill.car.and.ship.batch.query', json).then((res) => {
          let data
          if ((data = isSuccess(res))) {
            this.nameList = data
          }
        })
      }
    },
    //选择车牌号  给姓名数组赋值
    change(val) {
      if (this.getCar == true) {
        this.nameList = []
      }
      console.log(this.nameList.length, val)
      if (this.nameList.length == 0) {
        this.carrier_name_pid = ''
        this.carrier_name = ''
        this.accompany_mobile = ''
        this.getCar = true
        this.getName = false
        let obj = this.numList.find((item) => {
          return val === item.pid
        })
        let numObj = {
          numPid: obj.pid,
          ship_car_num: obj.ship_car_num
        }
        if (this.ship_car_num == '') {
          Object.keys(numObj).forEach((key) => {
            json.ship_car_num = ''
          })
        }
        this.$emit('getNum', numObj)
        let jsons = {
          pid: obj.pid,
          ship_car_type: this.ship_car_type
        }
        api('waybill.ship.and.driver.info.query', jsons).then((res) => {
          let data
          if ((data = isSuccess(res))) {
            this.nameList = data
            if (this.nameList.length == 1) {
              this.carrier_name_pid = this.nameList[0].pid
              // this.carrier_name = this.nameList[0].ship_car_name;

              let json = {
                phone: this.nameList[0].ship_car_phone,
                Cname: this.nameList[0].ship_car_name,
                Cpid: this.nameList[0].pid
              }
              if (this.carrier_name == '') {
                Object.keys(json).forEach((key) => {
                  json.Cname = ''
                })
              }
              this.$emit('getMsg', json)
            }
          }
        })
      } else {
        let obj = this.numList.find((item) => {
          return val === item.pid
        })
        let numObj = {
          ship_car_num: obj.ship_car_num
        }
        if (this.ship_car_num == '') {
          Object.keys(numObj).forEach((key) => {
            numObj.ship_car_num = ''
          })
        }
        this.$emit('getNum', numObj)
        let Cpid = this.numList.find((item) => {
          return val === item.pid
        }).pid
        let json = {
          Cpid
        }
        if (this.carrier_name == '') {
          Object.keys(json).forEach((key) => {
            json.Cpid = ''
          })
        }
        this.$emit('getMsg', json)
      }
    },
    // // 选择姓名，给车牌号数组赋值
    changeName(val) {
      if (this.getName == true) {
        this.numList = []
        this.carrier_name_pid = ''
        this.ship_car_num = ''
      }
      console.log(this.numList.length, val)
      if (this.numList.length !== 0) {
        let phone = this.nameList.find((item) => {
          return val === item.pid
        }).ship_car_phone
        let Cname = this.nameList.find((item) => {
          return val === item.pid
        }).ship_car_name
        let Cpid = this.nameList.find((item) => {
          return val === item.pid
        }).pid
        let json = {
          phone,
          Cname,
          Cpid
        }
        if (this.carrier_name == '') {
          Object.keys(json).forEach((key) => {
            json.Cname = ''
          })
        }
        this.$emit('getMsg', json)
      } else {
        this.getCar = false
        this.getName = true
        api('waybill.ship.and.driver.info.query', {
          pid: val,
          ship_car_type: this.ship_car_type
        }).then((res) => {
          let data
          if ((data = isSuccess(res))) {
            this.numList = data
            let phone = this.nameList.find((item) => {
              return val === item.pid
            }).ship_car_phone
            let Cname = this.nameList.find((item) => {
              return val === item.pid
            }).ship_car_name
            if (this.numList.length == 1) {
              console.log(this.numList)
              let Cpid = this.numList[0].pid
              let numObj = {
                ship_car_num: this.numList[0].ship_car_num
              }
              if (this.ship_car_num == '') {
                Object.keys(numObj).forEach((key) => {
                  numObj.ship_car_num = ''
                })
              }
              this.$emit('getNum', numObj)
            }
            let json = {
              phone,
              Cname,
              Cpid: this.numList[0].pid
            }
            if (this.carrier_name == '') {
              Object.keys(json).forEach((key) => {
                json.Cname = ''
              })
            }
            this.$emit('getMsg', json)
          }
        })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/carship/car-ship-msg.vue